import React from 'react';
import { useSocket } from '../hooks/useSocket';

const EMOJIS = ['🔥', '😂', '❤️', '🎉', '👀'];

// Floating reactions overlay — render ONCE per page (Session does this);
// every reaction from anyone at the party drifts up over the content.
export const ReactionOverlay = () => {
  const { reactions } = useSocket();

  return (
    <div className="fixed bottom-28 md:bottom-8 inset-x-0 pointer-events-none z-30 flex justify-center">
      <div className="relative w-full max-w-md h-0">
        {(reactions || []).map((r) => (
          <span
            key={r.id}
            className="jh-float-up absolute bottom-0 text-3xl"
            style={{ left: `${r.x}%` }}
            aria-hidden="true"
          >
            {r.emoji}
          </span>
        ))}
      </div>
    </div>
  );
};

// Tappable emoji pills — reusable wherever reacting makes sense
export const ReactionBar = ({ size = 'md', className = '' }) => {
  const { sendReaction } = useSocket();
  const btnCls = size === 'sm' ? 'text-base w-9 h-9' : 'text-xl w-11 h-11';

  return (
    <div className={`flex justify-center gap-2 ${className}`}>
      {EMOJIS.map((emoji) => (
        <button
          key={emoji}
          onClick={() => sendReaction(emoji)}
          className={`${btnCls} bg-gray-800/80 border border-white/10 rounded-full hover:scale-110 active:scale-90 transition-transform`}
          aria-label={`React with ${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

// Back-compat combined component (bar + overlay)
const Reactions = () => (
  <>
    <ReactionOverlay />
    <ReactionBar className="mt-4" />
  </>
);

export default Reactions;
